import _axios from "axios";
import authService from "./services/AuthService";
import { captureException } from "@sentry/vue";
import profileService from "./services/ProfileService";

export const baseURL = process.env.VUE_APP_BASE_URL + process.env.VUE_APP_WEBSERVICE_VERSION;
export const baseURLV2 = process.env.VUE_APP_BASE_URL + process.env.VUE_APP_BUSINESS_WEBSERVICE;

let Axios = _axios.create({
  baseURL,
  headers: { "Content-Type": "application/json" },
  params: process.env.NODE_ENV != "production" && { access_key: process.env.VUE_APP_STAGING_ACCESS_KEY },
});

Axios.interceptors.request.use(
  (config) => {
    if (authService.isAuthenticated)
      config.headers.Authorization = `Bearer ${authService.token}`;

    return config;
  },
  (error) => Promise.reject(error)
);

const handleSuccess = (result) => {
  return result.data;
};

const handleError = error => {
  captureException({
    errorMessage: error?.response?.data?.message,
    errorStatus: error?.response?.status,
    userId: authService?.id,
    providerId: profileService?.selectedProvider
  });

  switch (error?.response?.status) {
    case 401:
      authService.logout();
      location.reload();
      break;
    case 404:
      // 404 page not found
      break;
    default:
      // Default
      break;
  }

  return Promise.reject(error);
};

Axios.interceptors.response.use(handleSuccess, handleError);

export default Axios;
